import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CurrentUserStore, ShopStore, UserStore } from 'stores';
import MicrosoftAuthService from './MicrosoftAuthService';
import { notification, Spin, Form } from 'antd';
import styled from 'styled-components';
import { getShopId } from './MicrosoftConfig';

const Container = styled(Form)`
  padding-right: 7vw;
  h1 {
    font-size: 2.8rem;
    font-weight: 600;
    color: #000;
  }
  p {
    font-weight: 400;
    color: #8c8c8c;
    opacity: 0.9;
  }
`;
const LoadingScreen = styled.div`
  margin: auto;
  text-align: center;
`;

const MicrosoftCallback = () => {
  const history = useHistory();
  const [loadingText, setLoadingText] = useState(false);

  const createUser = async (user) => {
    try {
      return await UserStore.createUser(user);
    } catch (err) {
      console.log(err);
      throw new Error('Error in creating user');
    }
  };

  const loginUser = async (email, password) => {
    try {
      return await CurrentUserStore.login(email, password);
    } catch (err) {
      console.log(err);
      throw new Error('Error in login user');
    }
  };

  useEffect(() => {
    const t = setInterval(() => setLoadingText((p) => !p), 3000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    async function handleMicrosoftLoginSteps() {
      try {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        const authCode = urlParams.get('code');
        if (!authCode) throw new Error('Error in getting auth code');

        // Clear query to prevent code re-use on refresh
        window.history.replaceState({}, document.title, url.pathname);

        // Exchange code for token (supports both normalized and raw)
        const tokenResponse = await MicrosoftAuthService.getToken(authCode);
        const accessToken =
          tokenResponse.accessToken ||
          tokenResponse.access_token ||
          tokenResponse?.raw?.access_token;

        if (!accessToken) {
          console.error('Token response (no access token):', tokenResponse);
          throw new Error('No access token returned from Microsoft');
        }

        // Persist token in a consistent shape
        const normalizedToken = {
          accessToken,
          idToken:
            tokenResponse.idToken ||
            tokenResponse.id_token ||
            tokenResponse?.raw?.id_token,
          refreshToken:
            tokenResponse.refreshToken ||
            tokenResponse.refresh_token ||
            tokenResponse?.raw?.refresh_token,
          expiresIn:
            tokenResponse.expiresIn ||
            tokenResponse.expires_in ||
            tokenResponse?.raw?.expires_in,
          scope: tokenResponse.scope || tokenResponse?.raw?.scope,
          tokenType:
            tokenResponse.tokenType ||
            tokenResponse.token_type ||
            tokenResponse?.raw?.token_type,
          raw: tokenResponse.raw || tokenResponse,
        };
        sessionStorage.setItem('MsalToken', JSON.stringify(normalizedToken));

        // Fetch profile
        const profile = await MicrosoftAuthService.getUserInfo(accessToken);
        sessionStorage.setItem('MsalUserInfo', JSON.stringify(profile));

        // Onboard/login (mirrors Okta flow)
        const password = '0oahsr75dcB6E5h7T5d7';
        const email = profile.email;

        const newUser = {
          shopId: getShopId(),
          inviterId: 448,
          firstName: profile.firstName,
          lastName: profile.lastName,
          role: 'dealership',
          shopRole: 'fleetManager',
          phone: undefined,
          email,
          username: email,
          password,
          isSendCredentialsByPhone: false,
        };

        try {
          ShopStore.reset();

          // Try login first
          let user = null;
          try {
            user = await loginUser(email, password);
          } catch (loginErr) {
            user = null; // proceed to create
          }

          if (user) {
            notification.open({
              key: 'login',
              description: (
                <>
                  <Spin size="large" style={{ marginRight: '0.6rem' }} />
                  You are logging into Pitstop dashboard...
                </>
              ),
              duration: 0,
            });
            await CurrentUserStore.getCurrentUser();
          } else {
            notification.open({
              key: 'login',
              description: (
                <>
                  <Spin size="large" style={{ marginRight: '0.6rem' }} />
                  Your account is being configurated...
                </>
              ),
              duration: 0,
            });

            // Create (ignore conflict errors and try login)
            try {
              await createUser(newUser);
            } catch (createErr) {
              console.log(
                'Create user failed (might already exist):',
                createErr
              );
            }

            await loginUser(email, password);
            await CurrentUserStore.getCurrentUser();
          }
        } catch (err) {
          notification.error({
            message: 'Error',
            key: 'error',
            description: <Container>{err.message}</Container>,
          });
          throw err;
        } finally {
          notification.destroy('login');
        }

        history.push('/');
      } catch (err) {
        console.error('Error handling Microsoft callback:', err);
        history.push('/login');
      }
    }
    handleMicrosoftLoginSteps();
  }, [history]);

  return (
    <LoadingScreen>
      <div>
        <h1>Welcome to Pitstop Dashboard</h1>
        {loadingText ? (
          <p>
            Thank you for waiting while our AI Flywheel is hard at work
            analyzing your data!
          </p>
        ) : (
          <p>
            Did You Know? Pitstop's software analyzes over 30 Billion data
            points!
          </p>
        )}
        <Spin />
      </div>
    </LoadingScreen>
  );
};

export default MicrosoftCallback;
